// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1IojY","content":"GlobalSearch_content__1USKt"};